export function getFileNameFromUrl(url: string) {
  if (typeof url !== 'string') return '';

  return url.substring(url.lastIndexOf('/') + 1);
}
